import { TFunction } from 'i18next';
import { regexEmail } from './regexes';

export const getEmailRules = (t: TFunction) => ({
  required: { value: true, message: t('Email is required') },
  pattern: {
    value: regexEmail,
    message: t('Email is invalid'),
  },
});
